import {
  FETCH_DELETE_ENTITIES_REQUEST,
  FETCH_DELETE_ENTITIES_SUCCESS,
  FETCH_DELETE_ENTITIES_FAILURE,
} from "../../actions/entities/delete-entities-action";

const initialState = {
  removed: null,
  isLoading: false,
  error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const DeleteEntitiesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_DELETE_ENTITIES_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_DELETE_ENTITIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        removed: action.payload || true,
      };
    case FETCH_DELETE_ENTITIES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case CLEAR_DATA:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default DeleteEntitiesReducer;
